import img1 from '@/assets/images/index/reviews-01.png';
import img2 from '@/assets/images/index/reviews-02.png';
import img3 from '@/assets/images/index/reviews-03.png';
import img4 from '@/assets/images/index/reviews-04.png';
import img5 from '@/assets/images/index/reviews-05.png';
import img6 from '@/assets/images/index/reviews-06.png';

export const commentData = [
    {
        title: 'Bubble',
        content: `"Wow! I never thought a 3D printer could create something this detailed and artistic! The texture and depth make my pet’s portrait look so incredibly real."`,
        class: 'fir',
        img: img1
    },
    {
        title: 'Nina',
        content: `“This isn’t just a decoration—it’s a memory. Every time I look at it, I feel like my pet is right here with me. It’s something I’ll cherish forever.”`,
        class: 'sec',
        img: img2
    },
    {
        title: 'Cilantro',
        content: `“I had so much fun customizing my order! Being able to choose the background color and add my pet’s name made it feel truly personal. ”`,
        class: 'thr',
        img: img3
    },
    {
        title: 'Cola',
        content: `“I got this as a gift for a friend, and they were totally blown away! It’s such a unique and thoughtful present for pet lovers—way better than a plain old framed picture!”`,
        class: 'for',
        img: img4
    },
    {
        title: '33',
        content: `“The coolest part is that you can really feel the texture! Every friend who visits my home touches it and asks, ‘Where did you get this?!’ It’s such a fun conversation starter!”`,
        class: 'fiv',
        img: img5
    },
    {
        title: 'Paris',
        content: `“This is such a cool idea! The 3D effect really makes my pet’s features pop, and the color is very retro. It’s a perfect way to preserve memories!”`,
        class: 'six',
        img: img6
    }
];
